import axios from "axios";

const URL = 'https://isolution.dev.br:8091/siteadm';
//const URL = 'http://localhost:8091/siteadm';

const api = axios.create({
    baseURL: URL
});

export default api;